import { ApiClient } from "@/core/shared/api/domain/apiClient";
import { FacilityRepository } from "../domain/facilityRepository";
import { facilitiesDeserializer } from "./facilitiesDeserializer";

export const apiFacilityRepository = ({ apiClient }: { apiClient: ApiClient }): FacilityRepository => ({
  getFacilities: async () => {
    return await apiClient.get("/internal/facilities", { mapResponse: facilitiesDeserializer });
  },
});
